var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":"/contact/"}},[_vm._v("\n    会員についてのお問い合わせはこちら\n  ")])])}]

export { render, staticRenderFns }